import { Switch } from "react-router-dom";
import Clientes from "../../Pages/Geral/Cliente";
import GestaoClientes from "../../Pages/Geral/GestaoClientes";
import { TriagemEmails } from "../../Pages/Geral/Triagem";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import GestaoLeads from "../../Pages/Vendas/GestaoLeads/GestaoLeads";

const pathRotasGlobaisPorTela = {
    GESTAO_CLIENTES: [
        ACESSOS.GERAL.TELAS.GESTAO_CLIENTES.DS_PATH,
        ACESSOS.COBRANCA.TELAS.GESTAO_CLIENTES.DS_PATH,
        ACESSOS.ATENDIMENTO.TELAS.GESTAO_CLIENTES.DS_PATH,
        ACESSOS.ASSISTENCIA.TELAS.GESTAO_CLIENTES.DS_PATH,
        ACESSOS.VENDAS.TELAS.GESTAO_CLIENTES.DS_PATH,
        ACESSOS.REPASSE.TELAS.GESTAO_CLIENTES.DS_PATH,
        ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CLIENTES.DS_PATH,
    ],
    CLIENTE: [
        ACESSOS.GERAL.TELAS.CLIENTE.DS_PATH,
        ACESSOS.COBRANCA.TELAS.CLIENTE.DS_PATH,
        ACESSOS.ATENDIMENTO.TELAS.CLIENTE.DS_PATH,
        ACESSOS.ASSISTENCIA.TELAS.CLIENTE.DS_PATH,
        ACESSOS.VENDAS.TELAS.CLIENTE.DS_PATH,
        ACESSOS.REPASSE.TELAS.CLIENTE.DS_PATH,
        ACESSOS.HELPDESK.TELAS.CLIENTE.DS_PATH,
        ACESSOS.ENTREGA_DE_CHAVES.TELAS.CLIENTE.DS_PATH,
    ],
    TRIAGEM: [
        ACESSOS.GERAL.TELAS.TRIAGEM.DS_PATH,
        ACESSOS.COBRANCA.TELAS.TRIAGEM.DS_PATH,
        ACESSOS.ATENDIMENTO.TELAS.TRIAGEM.DS_PATH,
    ],
};

export default function RotasGlobais() {
    return (
        <Switch>
            <PrivatedRoute
                path={pathRotasGlobaisPorTela.GESTAO_CLIENTES}
                component={GestaoClientes}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.GESTAO_CLIENTES.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.VENDAS.TELAS.GESTAO_OPORTUNIDADES.DS_PATH}
                component={GestaoLeads}
                isPrivate
                idTela={ACESSOS.VENDAS.TELAS.GESTAO_OPORTUNIDADES.ID_TELA}
            />
            <PrivatedRoute
                path={pathRotasGlobaisPorTela.CLIENTE}
                component={Clientes}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.CLIENTE.ID_TELA}
            />
            <PrivatedRoute
                path={pathRotasGlobaisPorTela.TRIAGEM}
                component={TriagemEmails}
                isPrivate
                idTela={ACESSOS.GERAL.TELAS.TRIAGEM.ID_TELA}
            />
        </Switch>
    );
}

export const pathRotasGlobais = [
    ...pathRotasGlobaisPorTela.GESTAO_CLIENTES,
    ...pathRotasGlobaisPorTela.CLIENTE,
    ...pathRotasGlobaisPorTela.TRIAGEM,
    ACESSOS.VENDAS.TELAS.GESTAO_OPORTUNIDADES.DS_PATH,
];
